import React, { Fragment } from 'react';
import withCopyEdit from '../data-container';
import InfoBox from '../../components/info-box';
/**
 * Green / Water Infrastructure building side panel — under development per client.
 */
const WaterGreenInfrastructureView = () => {
    return (React.createElement(Fragment, null,
        React.createElement(InfoBox, { type: "warning" }, "This section is under development.")));
};
const WaterGreenInfrastructureContainer = withCopyEdit(WaterGreenInfrastructureView);
export default WaterGreenInfrastructureContainer;
